import Layout from '@/views/layout/Layout'
const independentRouter = {
    path: '/userCenter',
    name: 'userCenter',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 核销管理--出货单列表路由
        {
            path: 'logwriteoffSalesList',
            name: 'logwriteoffSalesList',
            meta: { name: '核销管理'},
            component: () => import('@/views/userCenter/writeoff/logwriteoffSalesList'),
        },
        // 核销管理--客户列表路由
        {
            path: 'logwriteoffCustomerList',
            name: 'logwriteoffCustomerList',
            meta: { name: '核销管理'},
            component: () => import('@/views/userCenter/writeoff/logwriteoffCustomerList'),
        },
        // 核销管理--导出清单路由
        {
            path: 'logwriteoffOutList',
            name: 'logwriteoffOutList',
            meta: { name: '核销管理'},
            component: () => import('@/views/userCenter/writeoff/logwriteoffOutList'),
        },
        // 核销管理--入账路由
        {
            path: 'logwriteoffFinancein',
            name: 'logwriteoffFinancein',
            meta: { name: '核销管理'},
            component: () => import('@/views/userCenter/writeoff/logwriteoffFinancein'),
        },
        // 核销管理--自动入账路由
        {
            path: 'logwriteoffFinanceinAuto',
            name: 'logwriteoffFinanceinAuto',
            meta: { name: '核销管理'},
            component: () => import('@/views/userCenter/writeoff/logwriteoffFinanceinAuto'),
        },
        // 核销管理--手动入账路由
        {
            path: 'logwriteoffFinanceinMan',
            name: 'logwriteoffFinanceinMan',
            meta: { name: '核销管理'},
            component: () => import('@/views/userCenter/writeoff/logwriteoffFinanceinMan'),
        },
        // 核销管理--核销记录路由
        {
            path: 'logwriteoffRecord',
            name: 'logwriteoffRecord',
            meta: { name: '核销记录'},
            component: () => import('@/views/userCenter/writeoff/logwriteoffRecord'),
        },
        // 核销管理--核销记录详情路由
        {
            path: 'logwriteoffRecordDetail',
            name: 'logwriteoffRecordDetail',
            meta: { name: '核销记录'},
            component: () => import('@/views/userCenter/writeoff/logwriteoffRecordDetail'),
        }
    ]
}
export default independentRouter


// WEBPACK FOOTER //
// ./src/router/modules/writeoff.js